import ActivityDetailBox from './ActivityDetailBox';

export default ActivityDetailBox;
